<div class="page__overlay" *ngIf="isLoadingPlanCondition || isLoadingRegister">
  <mat-spinner [diameter]="56" color="primary"></mat-spinner>
</div>

<div
  class="content"
  *ngIf="isLoadingPlanCondition || planCondition"
  [class.content--loading]="isLoadingRegister || isLoadingPlanCondition"
  [attr.aria-busy]="isLoadingRegister || isLoadingPlanCondition"
>
  <div class="content__overlay" *ngIf="isLoadingRegister">
    <mat-spinner [diameter]="56" color="primary"></mat-spinner>
  </div>

  <div class="logo" style="margin-bottom: 20px" *ngIf="!isLoadingPlanCondition && planCondition">
    <img src="assets/logoRegister.png" class="imgLogo" alt="Previdas Logo" />
  </div>

  <div class="plans__card" *ngIf="!isLoadingPlanCondition && planCondition">
    <h1 class="plans__card__name">
      {{ planCondition.name }}
    </h1>

    <div class="plans__card__body">
      <div class="plans__card__price" *ngIf="planCondition.prices?.length">
        <span class="plans__card__price__currency"> R$ </span>
        <span class="plans__card__price__value">
          {{ planCondition.prices[0].price }}
        </span>
        <span class="plans__card__price__occurrence">
          <span>/</span>
          <span>Mês</span>
        </span>
      </div>

      <div class="plans__card__renewal" *ngIf="planCondition.id !== 8; else monthly">
        Renovado anualmente
      </div>

      <ng-template #monthly>
        <div class="plans__card__renewal">Renovado mensalmente</div>
      </ng-template>
      <!-- reativado: limites do plano
      <div class="plans__card__limit">
        <div class="plans__card__limit__user" *ngIf="planCondition.userLimit !== null">
          <fa-icon icon="check"></fa-icon>
          <span class="plans__card__limit__user__quantity">
            {{ planCondition.userLimit }}
          </span>
          <span>
            <ng-container>Usuário</ng-container>
            <ng-container *ngIf="planCondition.userLimit > 1">s</ng-container>
          </span>
        </div>

        <div class="plans__card__limit__priority" *ngIf="planCondition.isSupportPriority !== null">
          <fa-icon icon="check"></fa-icon>
          <span>Agendamento e Suporte</span>
          <span class="plans__card__limit__priority__type" *ngIf="planCondition.isSupportPriority">Prioritário</span>
          <span class="plans__card__limit__priority__type" *ngIf="!planCondition.isSupportPriority">Normal</span>
        </div>

        <div class="plans__card__limit__schedules" *ngIf="planCondition.indicationLimit">
          <fa-icon icon="check"></fa-icon>
          <span class="plans__card__limit__schedules__quantity">
            {{ planCondition.indicationLimit }}
          </span>
          <span>agendamentos por ano</span>
        </div>

        <div class="plans__card__limit__schedules-ilimited" *ngIf="!planCondition.indicationLimit">
          <fa-icon icon="check"></fa-icon>
          <span>Agendamentos</span>
          <span class="plans__card__limit__schedules__quantity">ilimitados</span>
        </div>
      </div>

      <div class="plans__card__conditions" *ngIf="planCondition.consultations?.length">
        <h4>Preço por consulta</h4>
        <ng-container
          *ngFor="let consultations of planCondition.consultations"
          ngForTrackBy="consultations.id"
        >
          <div class="plans__card__consultations__details">
            <span class="plans__card__consultations__name">
              <span>&bullet;</span> {{ consultations.name }}
            </span>
            <span class="plans__card__consultations__price">
              {{ consultations.price | currency }}
            </span>
          </div>
        </ng-container>
      </div> -->
    </div>
  </div>

  <div class="account__card" *ngIf="!isLoadingPlanCondition && planCondition">
    <form [formGroup]="form" (ngSubmit)="onRegister()">
      <div class="row">
        <h4>Dados da Conta</h4>
      </div>

      <div class="row fields-grid">
        <span class="field field-cpf">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>CPF / CNPJ</mat-label>
            <input
              matInput
              formControlName="document"
              [specialCharacters]="documentCharset"
              [mask]="documentMask"
            />
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('document') }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="field field-name">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nome Completo</mat-label>
            <input matInput formControlName="name" />
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('name') }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="field field-email">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email" />
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('email') }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="field field-mobile">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Celular</mat-label>
            <input
              matInput
              formControlName="mobile"
              [specialCharacters]="['(', ')', ' ', '-']"
              mask="(00) 00000-0000"
            />
            <mat-error>
              {{ getControlErrorMessage('mobile') }}
            </mat-error>
          </mat-form-field>
        </span>
      </div>

      <div class="row row-header">
        <h4>Dados do usuário</h4>
      </div>

      <div class="row fields-grid">
        <span class="field">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>CPF do usuário</mat-label>
            <input
              matInput
              formControlName="userCpf"
              [specialCharacters]="cpfCharset"
              [mask]="cpfMask"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Copiar CPF da conta"
              matTooltip="Copiar CPF da conta"
              matTooltipPosition="above"
              [disabled]="
                ('' + (form.get('document')?.value || ''))
                  .split('.')
                  .join('')
                  .split('-')
                  .join('')
                  .split('/')
                  .join('').length !== 11
              "
              (click)="copyCpfFromDocument()"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('userCpf') }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="field">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>E-mail do usuário</mat-label>
            <input matInput formControlName="userEmail" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Copiar e-mail da conta"
              matTooltip="Copiar e-mail da conta"
              matTooltipPosition="above"
              [disabled]="!form.get('email')?.value"
              (click)="copyEmailFromAccount()"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('userEmail') }}
            </mat-error>
          </mat-form-field>
        </span>
      </div>

      <div class="row fields-grid-2">
        <span class="field">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Senha</mat-label>
            <input
              matInput
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              class="toggle-visibility"
              (click)="hidePassword = !hidePassword"
            >
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('password') }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="field">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirmar Senha</mat-label>
            <input
              matInput
              [type]="hidePasswordConfirm ? 'password' : 'text'"
              formControlName="passwordConfirm"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              class="toggle-visibility"
              (click)="hidePasswordConfirm = !hidePasswordConfirm"
            >
              <mat-icon>{{ hidePasswordConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage('passwordConfirm') }}
            </mat-error>
          </mat-form-field>
        </span>
      </div>

      <div class="row">
        <mat-checkbox formControlName="term" required class="checkbox">
          <span class="terms-text">
            Concordo com os
            <a href="https://previdas.com.br/termos-de-uso/" target="_blank">
              Termos de uso e política de privacidade
            </a>
          </span>
        </mat-checkbox>
        <mat-error *ngIf="!hasGroupError()">
          {{ getControlErrorMessage('term') }}
        </mat-error>
      </div>

      <div class="actions row">
        <a
          mat-button
          class="btn-green btn-large"
          href
          (click)="onRegister(); $event.preventDefault()"
          (mouseenter)="validateForm()"
          [attr.aria-disabled]="isLoadingRegister || !form.valid ? true : null"
        >
          Prosseguir
        </a>
      </div>
    </form>
  </div>
</div>

<ng-container *ngIf="!isLoadingPlanCondition && !planCondition">
  <div class="notfound">
    <p>Plano não encontrado ou inativo</p>
  </div>
</ng-container>
